import { CallbackObject } from 'api/core/get-page-function';
import { plainToClass } from 'class-transformer';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';
import { GetPreparationAreasVm } from './get-preparation-areas.vm';

export const getPreparationAreas = async (warehouseId: string, offset: string, callback: CallbackObject<GetPreparationAreasVm>) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
        params: {
            limit: 50,
            offset: offset,
        }
    };

    try {
        const res: AxiosResponse = await instance.get(`/production/warehouses/${warehouseId}/preparation-areas`, config);
        callback.success(plainToClass(GetPreparationAreasVm, res.data));
    } catch (err) {
        if (callback.error) callback.error(err);
    }
};
